module.exports = __webpack_public_path__ + "static/media/varais-2.fcbf00a9.jpg";